export class FavoriteListItemNotFoundError extends Error {
  constructor(
    public favoriteListId: string,
    public sku: string
  ) {
    super(`Item with sku ${sku} not found in favorite list ${favoriteListId}.`)
  }
}
